import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { px2rem } from '../utils/helpers/style.js';

var sizingsNative = {
  s: {
    height: 44,
    fontSize: 16,
    label: {
      activeFontSize: 12,
      activeTop: 5,
      inactiveTop: 13,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 13
    }
  },
  m: {
    height: 52,
    fontSize: 16,
    label: {
      activeFontSize: 12,

      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 8,
      inactiveTop: 17,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 17
    }
  },
  l: {
    height: 60,
    fontSize: 18,
    label: {
      activeFontSize: 12,

      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 10,
      inactiveTop: 20,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 20
    }
  }
};
var inputFieldAttributesNative = {
  /**
   * Affects label and border active colors
   */
  color: 'primary',

  /**
   * Affects input value text color
   */
  font: {
    color: 'text'
  },

  /**
   * Same as borderStyle prop. Used to define which borders are used. To style borderRadius use theme.borders.radius.
   */
  borderStyle: 'full',

  /**
   * Passed directly right side Icon as props
   */
  inputIconStyle: {
    size: 24,
    alignItems: 'center',
    color: colors.fogGrey,

    /**
     * Passed as color prop is disabled
     */
    disabled: colors.octoberGrey
  },

  /**
   * Passed directly as style prop to right side iconButton (wraps the icon)
   */
  iconButtonStyle: {
    marginHorizontal: 10,
    borderColor: 'transparent',
    backgroundColor: 'transparent'
  },
  input: {
    top: 4,
    paddingLeft: 16,
    paddingLeftWithBorder: 14,
    withLeftIcon: {
      paddingLeft: 55,
      paddingLeftWithBorder: 53
    }
  },
  errorColor: 'alert',
  backgroundColor: 'background',
  placeholderColor: colors.fogGrey,
  disabled: {
    border: {
      color: colors.fogGrey
    },
    label: {
      color: colors.fogGrey
    },
    backgroundColor: colors.lightGrey
  },
  readOnly: {
    border: {
      color: 'transparent'
    },
    label: {
      color: colors.octoberGrey
    }
  },
  inactive: {
    border: {
      color: colors.fogGrey
    },
    label: {
      color: 'text'
    },

    /**
     * Affects label when input field is not active
     */
    hasValueColor: colors.octoberGrey
  },
  label: {
    marginLeft: 18,
    marginLeftWithBorder: 18,
    withLeftIcon: {
      marginLeft: -1,
      marginLeftWithBorder: -1
    }
  },
  sizings: sizingsNative
};
var inputFieldThemeNative = _extends({}, inputFieldAttributesNative, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly',
      label: {
        marginLeft: 16,
        marginLeftWithBorder: 18,
        withLeftIcon: {
          marginLeft: -8,
          marginLeftWithBorder: -8
        }
      },
      input: {
        top: 0,
        paddingLeft: 14,
        paddingLeftWithBorder: 14,
        withLeftIcon: {
          paddingLeft: 48,
          paddingLeftWithBorder: 46
        }
      }
    }
  }
});
var inputFieldDarkThemeNative = _extends({}, inputFieldThemeNative, {
  placeholderColor: colors.octoberGrey,
  color: colors.cloudGrey,
  disabled: {
    border: {
      color: colors.octoberGrey
    },
    label: {
      color: colors.octoberGrey
    },
    backgroundColor: colors.mineShaftGrey
  },
  inactive: {
    border: {
      color: colors.octoberGrey
    },
    label: {
      color: 'text'
    },
    hasValueColor: colors.fogGrey
  }
});
var sizingsWeb = {
  s: {
    height: px2rem(48),
    fontSize: px2rem(16),
    icons: {
      rightIconSize: 24,
      leftIconSize: 24,
      top: px2rem(12)
    },
    label: {
      fontSize: px2rem(16),
      lineHeight: px2rem(48)
    },
    paddings: {
      input: {
        top: px2rem(18),
        bottom: px2rem(5)
      }
    }
  },
  m: {
    height: px2rem(56),
    fontSize: px2rem(18),
    icons: {
      rightIconSize: 24,
      leftIconSize: 24,
      top: px2rem(16)
    },
    label: {
      fontSize: px2rem(18),
      lineHeight: px2rem(56)
    },
    paddings: {
      input: {
        top: px2rem(18),
        bottom: px2rem(5)
      }
    }
  },
  l: {
    height: px2rem(64),
    fontSize: px2rem(18),
    icons: {
      rightIconSize: 32,
      leftIconSize: 32,
      top: px2rem(16)
    },
    label: {
      fontSize: px2rem(18),
      lineHeight: px2rem(64)
    },
    paddings: {
      input: {
        /**
         * Affects input position when text is entered or field is active
         */
        top: px2rem(28),

        /**
         * Affects input position when text is entered or field is active
         */
        bottom: px2rem(11)
      }
    }
  }
};
var inputFieldAttributesWeb = {
  color: 'primary',
  background: 'background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  inactive: colors.fogGrey,
  dismissIcon: colors.inkGrey,
  label: {
    color: colors.octoberGrey,
    fontWeight: 400
  },
  disabled: {
    background: colors.lightGrey,
    label: colors.fogGrey,
    border: colors.fogGrey
  },
  paddings: {
    label: {
      /**
       * Affects label vertical position
       */
      top: px2rem(0),

      /**
       * Affects label vertical position
       */
      bottom: px2rem(0)
    }
  },
  sizings: sizingsWeb
};
var inputFieldThemeWeb = _extends({}, inputFieldAttributesWeb, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly',
      disabled: {
        color: colors.fogGrey,
        label: colors.fogGrey
      }
    }
  }
});
var inputFieldDarkThemeWeb = _extends({}, inputFieldThemeWeb, {
  inactive: colors.octoberGrey,
  disabled: {
    background: colors.mineShaftGrey,
    label: colors.octoberGrey,
    border: colors.octoberGrey
  }
});

export { inputFieldDarkThemeNative, inputFieldDarkThemeWeb, inputFieldThemeNative, inputFieldThemeWeb, sizingsNative };
